/** Removes RxDB's storage metadata before a closed domain schema validates a document. */
export function withoutRxdbMetadata(value: unknown): unknown {
    if (value === null || typeof value !== 'object' || Array.isArray(value)) {
        return value;
    }

    const { _attachments, _deleted, _meta, _rev, ...document } = value as Record<string, unknown>;

    void _attachments;
    void _deleted;
    void _meta;
    void _rev;

    return document;
}
